export default {"src":"/_next/static/media/mail.1a45f70c.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};